import classNames from 'classnames';
import React, { FC } from 'react';

import styles from './InputLabel.module.css';

import { Typography } from '@/shared/components/atoms/Typography';

interface Props {
  className?: string;
  label: string;
  required?: boolean;
  id?: string;
  disabled?: boolean;
}
const InputLabel: FC<Props> = ({
  label,
  className,
  required,
  id,
  disabled,
}) => {
  const labelClasses = classNames(styles['label'], className, {
    [styles['label-disabled']]: disabled,
  });

  return (
    <label htmlFor={id} className={labelClasses}>
      <Typography variant='body2' weight='regular'>
        {label} {required && <span className={styles['required']}>*</span>}
      </Typography>
    </label>
  );
};

export default InputLabel;
